/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AutocompleteItemDto, ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet } from '@gh/core-data';
import { createLink } from '@gh/core-util';

import { ContactType } from '../contacts';
import { LetterDto } from '../letters';

export const CommunicationType = createEnum('COMMUNICATIONS_TYPE', {
  OutgoingSms: 'OUTGOING_SMS',
  IncomingSms: 'INCOMING_SMS',
  Email: 'EMAIL',
  Doc: 'DOC',
  ContactActivity: 'CONTACT_ACTIVITY',
  JobMeeting: 'JOB_MEETING',
  JobActivity: 'JOB_ACTIVITY',
  SalesMeeting: 'SALES_MEETING',
  SalesActivity: 'SALES_ACTIVITY',
  Website: 'WEBSITE',
});

export type CommunicationType = EnumSet<typeof CommunicationType>;

export type CommunicationAttachmentDto = {
  googleFileId: ID;
  googleFileName: string;
  mimeType: string;
  webViewLink: string;
  ownerId?: string;
};

export type CommunicationListItemDto = {
  jobId?: ID;
  contactId: ID;
  communicationType: CommunicationType;
  message: string;
  location?: string;
  created?: Date;
  attachments?: CommunicationAttachmentDto[];
  communicationId?: ID;
  email?: string;
  emailCc?: string;
  emailBcc?: string;
  subject?: string;
  cellPhone?: string;
  otherPhone?: string;
  contactTypeCode?: ContactType;
  createdByName?: string;
  isMarkedAsRead: boolean;
  isDone?: boolean;
  salesFolderId?: ID;
  startDate?: Date;
  endDate?: Date;
  milestoneEvent?: string;
  template?: AutocompleteItemDto;
};

export type Guest = {
  id: ID;
  contactName: string;
  email?: string;
};

export type GuestListItemDto = Guest & { recommended: boolean };

export type Assignee = Guest;

export type ActivityDetails = WithVersion<{
  allDay: boolean;
  id?: ID;
  activityType: any;
  addedDate?: Date;
  startDate: Date;
  endDate: Date;
  guests: ID[];
  location: string;
  description: string;
  notes: string;
  isDone: boolean;
  assignee: any;
  active: boolean;
  communicationType?: CommunicationType;
  communicationId?: ID;
  salesFolderId?: ID;
  created?: Date;
  contactTypeCode?: ContactType;
  milestoneEvent?: string;
}>;

export type CommunicationDataDto = {
  communications: CommunicationListItemDto[];
  gDriveUrl: string;
  gDriveFolderId: ID;
  isUnsubscribed: boolean;
};

export const attachmentFromLetter = ({ googleId, name, link, mimeType }: LetterDto) => ({
  googleFileId: googleId,
  googleFileName: name,
  webViewLink: link,
  mimeType,
});

export function createLinkFromAttachment(attachment: CommunicationAttachmentDto): string {
  return createLink(attachment.webViewLink, attachment.googleFileName);
}
